/* capkov-rd-live (3. 10.): živý slib odeslání + vánoční uzávěrka z ERP (cpcaps GET /api/public/ship-promise).
   Zásady:
   - nic neblokuje: fetch až po načtení stránky, timeout 2 s, výsledek v sessionStorage (60 s čerstvý, 15 min nouzově)
   - bez dat / při chybě / při level=green a bez uzávěrky se NEDĚLÁ NIC (web se chová přesně jako dřív)
   - žádné rezervované místo: liště pro uzávěrku je překryv (position: fixed), texty ETA se jen přepíšou na místě
   - texty ETA přepisujeme idempotentně (MutationObserver), protože je jinak každých 30 s přepočítávají skripty PDP / úvodu / košíku */
(function () {
  'use strict';
  /* ===== KONFIG: jediné místo s adresou. TEST = staging, go-live = ostrá adresa ===== */
  var RD_LIVE_URL = 'https://cpcaps.com/api/public/ship-promise';
  /* ================================================================================= */
  var KEY = 'rdShipPromise', XKEY = 'rdLiveBarX', FRESH = 60000, STALE = 900000, TMO = 2000;
  var DATA = null, MO = null, raf = 0;
  var EN = !!(window.RD_LOC && window.RD_LOC !== 'cs');
  function ft(s) { return EN ? '' : s; } /* volný český text z ERP se v angličtině nezobrazuje */
  function F(k, d, a) { var s = RT('home.live.' + k, d); for (var i = 0; i < (a || []).length; i++) s = s.replace('{' + i + '}', a[i]); return s; }

  function esc(t) { return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function ss(fn) { try { return fn(window.sessionStorage); } catch (e) { return null; } }
  function valid(d) { return d && typeof d === 'object' && d.version === 1 && /^(green|amber|red)$/.test(d.level); }
  function readCache(maxAge) {
    var r = ss(function (s) { return s.getItem(KEY); }); if (!r) return null;
    try { var o = JSON.parse(r); if (o && valid(o.d) && Date.now() - o.t < maxAge) return o; } catch (e) { }
    return null;
  }

  /* ---------- pražské datum ---------- */
  function pragueToday() {
    try {
      var o = {}; new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Prague', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date()).forEach(function (p) { if (p.type !== 'literal') o[p.type] = parseInt(p.value, 10); });
      return Date.UTC(o.year, o.month - 1, o.day);
    } catch (e) { var n = new Date(); return Date.UTC(n.getFullYear(), n.getMonth(), n.getDate()); }
  }
  function dmy(iso) { var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || ''); if (!m) return ''; return window.RDD.dm(Date.UTC(+m[1], +m[2] - 1, +m[3])); }
  /* "2026-10-05" -> zítra / v pondělí 5. 10. */
  function dayLabel(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || ''); if (!m) return '';
    var t = Date.UTC(+m[1], +m[2] - 1, +m[3]), d = Math.round((t - pragueToday()) / 86400000);
    if (d <= 0) return F('today', 'dnes'); if (d === 1) return F('tomorrow', 'zítra');
    return window.RDD.onDate(t);
  }
  function hhmm(dl) { var m = /T(\d{2}):(\d{2})/.exec(dl || ''); return m ? (+m[1]) + ':' + m[2] : ''; }

  /* ---------- co ukázat pro daný typ (stock | text | image) ---------- */
  function closureOn() { var c = DATA && DATA.christmas; return !!(c && c.enabled && c.visible); }
  function closedRow(kind) {
    if (!closureOn()) return null;
    var rows = DATA.christmas.rows || [];
    for (var i = 0; i < rows.length; i++) if (rows[i].kind === kind && rows[i].status === 'closed') return rows[i];
    return null;
  }
  function openRow(kind) {
    if (!closureOn()) return null;
    var rows = DATA.christmas.rows || [];
    for (var i = 0; i < rows.length; i++) if (rows[i].kind === kind && rows[i].status === 'open') return rows[i];
    return null;
  }
  function slow() { return DATA && DATA.level !== 'green'; }
  function st(kind) {
    kind = kind === 'image' || kind === 'text' ? kind : 'stock';
    var cr = closedRow(kind);
    if (cr) {
      var when = dmy((cr.deadline || '').slice(0, 10));
      var xm = F('xmas', 'Objednávky po {0} <b>doručíme po Vánocích</b>', [esc(when)]);
      return { kind: 'xmas', title: xm, main: xm, sub: esc(ft(cr.note || (DATA.christmas.disclaimer || ''))), short: F('xmas_short', 'Objednávky po {0} doručíme po Vánocích.', [when]), cart: xm, d: F('after_xmas', 'po Vánocích'), home: F('home_xmas', 'Domů přes GLS / PPL / DPD: po Vánocích') };
    }
    if (slow()) {
      var day = dayLabel(DATA.ship_by && DATA.ship_by[kind]), tx = esc(ft(DATA.text || ''));
      var lead = F('slow', 'Teď to trvá déle: odesíláme zpravidla <b>{0}</b>', [esc(day)]);
      var o = openRow(kind), sub = tx ? tx.charAt(0).toUpperCase() + tx.slice(1) : '';
      if (o) sub += (sub ? ' · ' : '') + (!sub && EN ? F('order_by_cap', 'Na Vánoce objednej do {0}', [esc(dmy((o.deadline || '').slice(0, 10)))]) : F('order_by', 'na Vánoce objednej do {0}', [esc(dmy((o.deadline || '').slice(0, 10)))]));
      return { kind: 'slow', title: lead, main: lead, sub: sub, short: EN ? F('slow_short', '', [day.replace(/\.$/, '')]) : 'Teď to trvá déle: ' + (DATA.text || '') + (day ? ', odesíláme zpravidla ' + day.replace(/\.$/, '') : '') + '.', cart: F('slow_cart', 'teď to trvá déle, odesíláme zpravidla <b>{0}</b>', [esc(day)]) + (tx ? ' (' + tx + ')' : ''), d: day, home: F('home_slow', 'Domů přes GLS / PPL / DPD: většinou den po odeslání') };
    }
    var o2 = openRow(kind);
    if (o2) return { kind: 'open', sub: F('order_by_cap', 'Na Vánoce objednej do {0}', [esc(dmy((o2.deadline || '').slice(0, 10)))]) + (hhmm(o2.deadline) ? ', ' + hhmm(o2.deadline) : ''), short: '' };
    return null;
  }

  /* ---------- aplikace na DOM (idempotentní) ---------- */
  function setHTML(el, h) { if (el && el.innerHTML !== h) el.innerHTML = h; }
  function setTxt(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function hide(el) { if (el && !el.hidden) el.hidden = true; }
  function apply() {
    raf = 0;
    if (!DATA) return;
    if (MO) MO.disconnect();
    try {
      /* PDP: průvodce (data-rdx-eta) */
      [].forEach.call(document.querySelectorAll('[data-rdx-eta]'), function (el) {
        var s = st(el.getAttribute('data-kind')); if (!s) return;
        var ti = el.querySelector('[data-rdx-title]'), sub = el.querySelector('[data-rdx-sub]'), co = el.querySelector('[data-rdx-count]'), ds = el.querySelectorAll('[data-rdx-d]'), home = el.querySelector('[data-rdx-home]');
        if (s.kind !== 'open') {
          setHTML(ti, s.title); hide(co);
          if (ds[1]) setTxt(ds[1], s.d); if (ds[2]) setTxt(ds[2], s.d); if (ds[3]) setTxt(ds[3], s.kind === 'xmas' ? F('after_xmas', 'po Vánocích') : F('after_dispatch', 'po odeslání'));
          if (home) setTxt(home, s.home);
        }
        if (sub && s.sub) setHTML(sub, s.sub);
      });
      /* úvod a kapitoly: věta pod hlavní nabídkou (data-rd-eta) */
      [].forEach.call(document.querySelectorAll('[data-rd-eta]'), function (el) {
        var s = st(el.getAttribute('data-rd-mode')); if (!s) return;
        var main = el.querySelector('[data-rd-eta-main]'), sub = el.querySelector('[data-rd-eta-sub]'), cnt = el.querySelector('[data-rd-eta-count]');
        if (s.kind !== 'open') { setHTML(main, s.main); hide(cnt); }
        if (sub && s.sub) setHTML(sub, s.sub);
      });
      /* úvodní stránka: věta pod bannery a drobný text v hrdinovi */
      var hs = st('stock');
      if (hs && hs.kind !== 'open') {
        [].forEach.call(document.querySelectorAll('.rdb__line > span'), function (el) { setHTML(el, hs.main); });
        [].forEach.call(document.querySelectorAll('.vd-fine > b:first-child'), function (el) { if (el.hasAttribute('data-rd-ship') || /^Skladem do|^Objednáš dnes|^Teď to trvá|^Objednávky po/.test(el.textContent)) { setHTML(el, hs.main); el.setAttribute('data-rd-ship-lock', '1'); } });
      }
      /* košík: slib doručení */
      [].forEach.call(document.querySelectorAll('[data-rdc-promise]'), function (el) {
        var t = el.querySelector('[data-rdc-promise-txt]'); if (!t) return;
        var stock = +el.getAttribute('data-stock') || 0, cu = +el.getAttribute('data-custom') || 0, h = '', a = st('stock'), b = st('text');
        if (stock && a && a.kind !== 'open') h += '<p>' + F('stock_items', 'Skladové kusy: ') + a.cart + '.</p>';
        if (cu && b && b.kind !== 'open') h += '<p>' + F('custom_items', 'Vlastní design: ') + b.cart + '.</p>';
        if (h) setHTML(t, h);
      });
      /* kolekce: tooltip „Doručení do 48 h“ */
      var f = st('stock');
      if (f && f.kind !== 'open') [].forEach.call(document.querySelectorAll('.rd-f48__tip'), function (t) {
        setTxt(t, f.short + F('f48_tip', ' Jen hotové kousky skladem, vlastní design se vyrábí na zakázku.'));
      });
    } catch (e) { }
    watch();
  }
  function schedule() { if (!raf) raf = (window.requestAnimationFrame || setTimeout)(apply); }
  function watch() {
    if (!window.MutationObserver) return;
    if (!MO) MO = new MutationObserver(schedule);
    MO.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  /* ---------- lišta uzávěrky (překryv, nic neposouvá) ---------- */
  function hash(s) { var h = 0; for (var i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0; return String(h); }
  function rlab(r) { if (!EN) return r.label; var k = r.kind === 'image' ? 'k_image' : r.kind === 'text' ? 'k_text' : 'k_stock'; return F(k, r.label); }
  function barText() {
    var c = DATA.christmas, m = ft((c.message || '').trim());
    if (m) return m;
    var rows = (c.rows || []).filter(function (r) { return r.status === 'open'; });
    return rows.length ? F('bar', 'Vánoční uzávěrka: {0} do {1}', [rlab(rows[0]), dmy((rows[0].deadline || '').slice(0, 10))]) : '';
  }
  function bar() {
    var old = document.getElementById('rd-live-bar');
    if (!closureOn()) { if (old) old.remove(); return; }
    var txt = barText(); if (!txt) { if (old) old.remove(); return; }
    var sig = hash(txt + '|' + (DATA.christmas.phase || ''));
    if (ss(function (s) { return s.getItem(XKEY); }) === sig) { if (old) old.remove(); return; }
    if (old && old.getAttribute('data-sig') === sig) return;
    if (old) old.remove();
    if (!document.getElementById('rd-live-css')) {
      var st1 = document.createElement('style'); st1.id = 'rd-live-css';
      st1.textContent = '#rd-live-bar{position:fixed;left:0;right:0;top:0;z-index:2147483000;margin:0;font:600 12px/1.25 inherit;font-family:inherit;color:#fff;background:#1a1a1a;box-shadow:0 1px 0 rgba(255,255,255,.12),0 4px 14px rgba(0,0,0,.25);transform:translateZ(0)}'
        + '#rd-live-bar .rdl__row{display:flex;align-items:center;gap:8px;min-height:30px;padding:5px 8px 5px 14px}'
        + '#rd-live-bar .rdl__t{flex:1;min-width:0;background:none;border:0;color:inherit;font:inherit;text-align:left;padding:0;cursor:pointer;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}'
        + '#rd-live-bar .rdl__t[aria-expanded=true]{white-space:normal}'
        + '#rd-live-bar .rdl__x{flex:none;width:28px;height:28px;border:0;background:none;color:inherit;font-size:18px;line-height:1;cursor:pointer;opacity:.8}'
        + '#rd-live-bar .rdl__more{padding:2px 14px 10px;font-weight:400;opacity:.92}'
        + '#rd-live-bar .rdl__more ul{margin:6px 0 4px;padding:0;list-style:none}#rd-live-bar .rdl__more li{padding:2px 0}'
        + '#rd-live-bar .rdl__more li.is-closed{opacity:.55;text-decoration:line-through}'
        + '@media (prefers-reduced-motion:no-preference){#rd-live-bar{animation:rdlIn .25s ease-out}@keyframes rdlIn{from{opacity:0}to{opacity:1}}}';
      document.head.appendChild(st1);
    }
    var rows = (DATA.christmas.rows || []).map(function (r) {
      return '<li class="' + (r.status === 'closed' ? 'is-closed' : '') + '"><b>' + esc(rlab(r)) + '</b>: ' + esc(F('row', 'do {0}', [dmy((r.deadline || '').slice(0, 10))])) + (hhmm(r.deadline) ? ', ' + esc(hhmm(r.deadline)) : '') + (r.note && !EN ? ' (' + esc(r.note) + ')' : '') + '</li>';
    }).join('');
    var b = document.createElement('div'); b.id = 'rd-live-bar'; b.setAttribute('data-sig', sig); b.setAttribute('role', 'region'); b.setAttribute('aria-label', F('bar_label', 'Vánoční uzávěrka'));
    b.innerHTML = '<div class="rdl__row"><button type="button" class="rdl__t" aria-expanded="false">' + esc(txt) + '</button><button type="button" class="rdl__x" aria-label="' + esc(F('close', 'Zavřít oznámení')) + '">×</button></div>'
      + '<div class="rdl__more" hidden>' + (rows ? '<ul>' + rows + '</ul>' : '') + (DATA.christmas.disclaimer && !EN ? '<div>' + esc(DATA.christmas.disclaimer) + '</div>' : '') + '</div>';
    var t = b.querySelector('.rdl__t'), more = b.querySelector('.rdl__more'), x = b.querySelector('.rdl__x');
    t.addEventListener('click', function () { var o = more.hidden; if (!rows && !DATA.christmas.disclaimer) return; more.hidden = !o; t.setAttribute('aria-expanded', o ? 'true' : 'false'); });
    x.addEventListener('click', function () { ss(function (s) { s.setItem(XKEY, sig); }); b.remove(); });
    document.body.appendChild(b);
  }

  /* ---------- načtení ---------- */
  function use(d) { DATA = d; apply(); bar(); }
  function load() {
    var c = readCache(FRESH);
    if (c) { use(c.d); return; }
    var stale = readCache(STALE); if (stale) use(stale.d);
    if (!window.fetch) return;
    var ctl = window.AbortController ? new AbortController() : null, to = setTimeout(function () { if (ctl) ctl.abort(); }, TMO);
    fetch(RD_LIVE_URL, { method: 'GET', mode: 'cors', credentials: 'omit', signal: ctl ? ctl.signal : undefined, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        clearTimeout(to);
        if (!valid(d)) return;
        ss(function (s) { s.setItem(KEY, JSON.stringify({ t: Date.now(), d: d })); });
        use(d);
      })
      .catch(function () { clearTimeout(to); });
  }
  function start() {
    var c = readCache(STALE); if (c) use(c.d);          /* před prvním vykreslením z cache, ať nic neblikne */
    var go = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 50); })(load, { timeout: 1500 }); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
